import { IKnmListFilterRaw } from 'APIPackage/KnmListModule/interfaces/IKnmListFilterRaw';
import { getStorageItem } from 'CorePackage/MainModule/common/localStore';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getLawInterface } from 'CorePackage/MainModule/reducers/coreReducer';
import { mapKnmFilterToRaw } from 'KnmListPackage/KnmListFiltersModule/common/mapKnmFilterToRaw';
import { initialKnmListFilter } from 'KnmListPackage/KnmListFiltersModule/constants/initialKnmListFilter';
import { IKnmListFilter } from 'KnmListPackage/KnmListFiltersModule/interfaces/IKnmListFilter';
import { getKnmListFilterPlanNum } from 'KnmListPackage/KnmListFiltersModule/selectors/knmListFilterSelectors';

export function getRawFilter(state: IRootState): IKnmListFilterRaw {
  const planNum = getKnmListFilterPlanNum(state);
  const isErknm = getLawInterface(state) === LawInterfacesEnum.FZ_248;
  const current = getStorageItem<IKnmListFilter>(StorageNamesEnum.KNM_FILTER);
  const isFilterOn = !!getStorageItem(StorageNamesEnum.KNM_FILTER_ON);
  const rawFilterData = mapKnmFilterToRaw((isFilterOn && current) || initialKnmListFilter, isErknm);

  return {
    ...rawFilterData,
    planNum: planNum || rawFilterData.planNum,
  };
}
